module.exports = __webpack_public_path__ + "client/img/s_item_17.7e137852.png";